export const REVENUECAT_ANONYMOUS_APP_USER_ID_PREFIX = "$RCAnonymousID:";

export function isRevenueCatAnonymousAppUserId(value: unknown): boolean {
  return typeof value === "string" && value.startsWith(REVENUECAT_ANONYMOUS_APP_USER_ID_PREFIX);
}

export function normalizeRevenueCatAppUserId(appUserId: string): string {
  const trimmedId = appUserId.trim();
  return isRevenueCatAnonymousAppUserId(trimmedId) ? trimmedId : trimmedId.toLowerCase();
}
